/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li3Inputs */

const tr_kvkkbasvuru_s3_li3 = /** @type {(inputs: Kvkkbasvuru_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebligata esas yerleşim yeri veya iş yeri adresi`)
};

const en_kvkkbasvuru_s3_li3 = /** @type {(inputs: Kvkkbasvuru_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Residential or business address used for service of notice`)
};

const de_kvkkbasvuru_s3_li3 = /** @type {(inputs: Kvkkbasvuru_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Zustellung maßgebliche Wohn- oder Geschäftsadresse`)
};

const ru_kvkkbasvuru_s3_li3 = /** @type {(inputs: Kvkkbasvuru_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес места жительства или места работы для направления уведомлений`)
};

/**
* | output |
* | --- |
* | "Residential or business address used for service of notice" |
*
* @param {Kvkkbasvuru_S3_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li3 = /** @type {((inputs?: Kvkkbasvuru_S3_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li3(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li3(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li3(inputs)
	return tr_kvkkbasvuru_s3_li3(inputs)
});